export enum RepaymentScheduleType {
  weekly = "weekly",
  biWeekly = "bi_weekly",
  monthlyExactDay = "monthly_exact_day",
  monthlyNthWeek = "monthly_nth_week",
}

export interface ApiAdminRepaymentSchedule {
  id: string;
  scheduleType: RepaymentScheduleType;
  recurringDayOfMonth: number | null;
  recurringDayOfWeek: number | null;
  recurringWeekOfMonth: number | null;
  previousBiWeeklyPayDate: string | null;
  active: boolean;
  activeAt: string | null;
  inactiveAt: string | null;
  approvalStatus: string;
  createdAt: string;
  updatedAt: string;
}

export interface ApiAdminRepaymentScheduleRequest {
  userId: string;
  scheduleType: RepaymentScheduleType;
  recurringDayOfWeek?: number;
  recurringDayOfMonth?: number;
  recurringWeekOfMonth?: number;
  previousBiWeeklyPayDate?: string;
  active: boolean;
}
